<div class="dialog-title-bar">
  <h2 mat-dialog-title>Rock File Preview</h2>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="preview-content">
    <div class="file-info">
      <strong>{{ getFileNameWithoutExtension() }}</strong>
      <p class="subtitle">Upscaling Segmented Rock Image</p>
    </div>

    <div class="image-and-phases">
      <div class="image-section">
        @if (isLoadingThumbnail) {
          <div class="loading-state">
            <mat-spinner diameter="50"></mat-spinner>
            <p>Loading thumbnail...</p>
          </div>
        } @else if (thumbnailError || !thumbnailUrl) {
          <div class="error-state">
            <mat-icon>image_not_supported</mat-icon>
            <p>Thumbnail not available</p>
          </div>
        } @else {
          <div class="thumbnail-container">
            <img [src]="thumbnailUrl" alt="Rock image thumbnail" class="rock-thumbnail" />
          </div>
        }
      </div>

      <div class="phases-section">
        @if (isLoadingMetadata) {
          <div class="loading-state">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Loading phase data...</p>
          </div>
        } @else if (metadataError || !phases.length) {
          <div class="error-state">
            <mat-icon>error_outline</mat-icon>
            <p>Phase data not available</p>
          </div>
        } @else {
          <div class="phases-table-container">
            <table class="phases-table">
              <colgroup>
                <col style="width: 60px" />
                <col style="width: 60px" />
                <col style="width: 100px" />
              </colgroup>
              <thead>
                <tr>
                  <th>Phase</th>
                  <th>Label</th>
                  <th>Fraction</th>
                </tr>
              </thead>
              <tbody>
                @for (phase of phases; track phase.phase) {
                  <tr>
                    <td>
                      <div class="phase-indicator" [style.background-color]="phase.color"></div>
                    </td>
                    <td>{{ phase.label }}</td>
                    <td>{{ phase.fraction | number : '1.3-3' }}</td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <tr class="total-row">
                  <td colspan="2">Total</td>
                  <td>{{ totalFraction | number : '1.3-3' }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        }
      </div>
    </div>
  </div>
</mat-dialog-content>
